import { useState } from "react";
import { ConfirmationModal } from "../../layout/ConfirmationModal";

export const useDeleteContactConfirmation = (
	name: string,
	onDelete?: () => void,
	deleteSubMessage?: string,
) => {
	const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

	const requestDelete = onDelete ? () => setShowDeleteConfirmation(true) : undefined;

	const confirmationModal = showDeleteConfirmation ? (
		<ConfirmationModal
			message={`Are you sure you want to delete ${name}?`}
			subMessage={deleteSubMessage ?? "This action cannot be undone."}
			confirmButtonText="Delete"
			confirmButtonTestId="confirm-delete-contact"
			confirmationButtonColor="danger"
			onConfirm={() => {
				setShowDeleteConfirmation(false);
				onDelete?.();
			}}
			onCancel={() => setShowDeleteConfirmation(false)}
		/>
	) : null;

	return { requestDelete, confirmationModal };
};
